// The location bar under the panel's header, on a brand with several locations (D4). Wording from the Amigo design's
// copy sheet (Location bar).
export default {
  label: 'Toimipaikka',
  all_one: 'Kaikki {{count}} toimipaikkaa',
  all_other: 'Kaikki {{count}} toimipaikkaa',
};
